import { render, staticRenderFns } from "./HomeDetail.vue?vue&type=template&id=61100146&scoped=true"
import script from "./HomeDetail.vue?vue&type=script&lang=js"
export * from "./HomeDetail.vue?vue&type=script&lang=js"
import style0 from "./HomeDetail.vue?vue&type=style&index=0&id=61100146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61100146",
  null
  
)

export default component.exports